import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import {
  CropFieldsSyncResponse,
  CropFieldType,
  TriggerSyncCropFieldsRequest,
  CropFieldSyncDto,
  SyncCropFieldsRequest,
  ExternalCropFieldSources,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class SyncService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/field-plan/secure/syncdata`;
  protected baseUrlArableAdvice = this.env.APIM_BASE_URL + '/arable-advice-service/';

  // Legacy method for V1 sync
  getSyncDataStatus(
    cropFieldType: CropFieldType,
    externalCropFieldSource: string,
    cropYear: number,
    searchYear: number,
    externalId: string,
  ): Observable<CropFieldsSyncResponse> {
    return this.http.get<CropFieldsSyncResponse>(
      `${this.baseUrl}/status/${cropFieldType}/${externalCropFieldSource}/${cropYear}/${externalId}/${searchYear}`,
    );
  }

  // V2 Sync Methods

  /**
   * Triggers the async crop field synchronization process
   * POST sync/trigger/{cropYear}
   */
  triggerSyncCropFields(cropYear: number, request: TriggerSyncCropFieldsRequest): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrlArableAdvice}crop-fields/sync/trigger/${cropYear}`,
      request,
    );
  }

  /**
   * Gets the crop field sync preview data after SignalR notification
   * GET sync/preview/{externalCropFieldSource}/{externalId}
   */
  getCropFieldSyncPreview(
    externalCropFieldSource: ExternalCropFieldSources,
    externalId: string,
  ): Observable<CropFieldSyncDto> {
    return this.http.get<CropFieldSyncDto>(
      `${this.baseUrlArableAdvice}crop-fields/sync/preview/${externalCropFieldSource}/${externalId}`,
    );
  }

  /**
   * Completes the sync with selected crop fields
   * POST sync/{externalCropFieldSource}/{externalId}
   */
  completeSyncCropFields(cropYear: number, request: SyncCropFieldsRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrlArableAdvice}crop-fields/sync/${cropYear}`, request);
  }
}
